import { KeyboardArrowDownIcon, makeStyles, Theme } from '@freighthub/silhouette-core'
import cn from 'classnames'
import { FC } from 'react'

const useStyles = makeStyles<Theme>({
  root: {
    transition: 'all 0.3s ease',
  },
  active: {
    transform: 'rotate(180deg)',
  },
})

interface ArrowDownCollapserProps {
  active: boolean
  className?: string
}
export const ArrowDownCollapser: FC<ArrowDownCollapserProps> = ({ active, className }) => {
  const classes = useStyles()
  return <KeyboardArrowDownIcon className={cn(classes.root, { [classes.active]: active }, className)} />
}
